export enum PopupSizeEnum {
  NORMAL = 'normal',
  LARGE = 'large'
}